import { CSSObject } from "@emotion/react";
import { typographyStyles, constants } from "@newsela/angelou";
const { heading4Obj, fontFamily } = typographyStyles;
const {
  colors: { ui, product },
} = constants;

export const cardCss: CSSObject = {
  border: "none",
  borderRadius: "16px",
  height: "168px",
  "a:first-of-type:after": {
    borderRadius: "16px",
  },
};

export const cardContentCss: CSSObject[] = [
  {
    alignItems: "center",
    display: "flex",
    fontWeight: 700,
    gap: "8px",
    padding: "16px 20px",
    margin: "0 8px 8px 0",
  },
  heading4Obj,
  fontFamily.noto,
];

export const searchIconCss: CSSObject = {
  minWidth: "24px",
  minHeight: "24px",
};

export const cardImageCss: CSSObject = {
  svg: {
    position: "absolute",
    right: 10,
    bottom: 0,
    maxHeight: "120px",
  },
};

export const variant1Css: CSSObject = {
  backgroundColor: ui.core[25],
};

export const variant2Css: CSSObject = {
  backgroundColor: ui.red[50],
};

export const variant3Css: CSSObject = {
  backgroundColor: product.formative[50],
};

export const variant4Css: CSSObject = {
  backgroundColor: ui.green[50],
};

export const variant5Css: CSSObject = {
  backgroundColor: ui.purple[25],
};
